import script from "./QueueDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./QueueDetailPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__